export const INVOICING_FREQUENCY = [
  {
    id: 1,
    name: "Single-Time",
  },
  {
    id: 2,
    name: "Milestone-Based",
  }
];

export const HARDWARE_TAGS_FREQUENCY = [
  {
    id: 1,
    name: "Solution-Level",
  },
  {
    id: 2,
    name: "BOQ-Level",
  }
];

export const CONSUMABLES_FREQUENCY = [
  {
    id: 1,
    name: "Solution-Level",
  },
  {
    id: 2,
    name: "BOQ-Level",
  }
];

export const SINGLE_INVOICE_LINES = [1, 2, 3, 4];

export const SOLUTION_INVOICE_LINES = [1, 2, 3, 4];

export const CONSUMABLE_INVOICE_LINES = [1, 2, 3, 4];

export const CONSUMABLE_BOQ_ITEMS = [
  {
    id: 3030,
    name: "Hardware BOQ"
  },
  {
    id: 3033,
    name: "Tags BOQ"
  },
  {
    id: 3045,
    name: "Consumables BOQ"
  }
];

export const SOLUTION_BOQ_ITEMS = [
  {
    id: 3030,
    name: "Hardware BOQ"
  },
  {
    id: 3033,
    name: "Tags BOQ"
  }
];

export const SINGLE_LINE_SOL_ITEMS = [
  {
    id: 3031,
    name: "Installation"
  },
  {
    id: 3032,
    name: "Cartage"
  }
];

export const CONSUMABLE_LINE_ITEMS = [
  {
    id: 3046,
    name: "Labour"
  },
  {
    id: 3032,
    name: "Cartage"
  }
];

export const MILESTONES = [
  {
    id: 3051,
    name: "Advance"
  },
  {
    id: 3,
    name: "Material Delivery"
  },
  {
    id: 4,
    name: "Hardware Installation"
  },
  {
    id: 5,
    name: "Handover Testing"
  }
];

export const SINGLE_LINE_ITEMS = [
  {
    id: 3030,
    name: "Hardware"
  },
  {
    id: 3031,
    name: "Installation"
  },
  {
    id: 3032,
    name: "Cartage"
  },
  {
    id: 3033,
    name: "Tags"
  }
];

export const HARDWARE_NOMENCLATURE_LINES = [
  'Hardware', 
  'Installation', 
  'Cartage',
  'Tags'
];

export const NOMENCLATURE_LINES = [
  'Installation', 
  'Cartage'
];

export const CONSUMABLE_NOMENCLATURE_LINES = [
  'Labour', 
  'Cartage'
];

// Common table styling constants
export const TABLE_STYLES = {
  table: {
    border: '1px solid #212529'
  },
  cell: {
    borderTop: '1px solid #212529',
    backgroundColor: '#f0f0f0'
  },
  header: {
    borderTop: '1px solid #212529',
    backgroundColor: '#f0f0f0'
  }
};

// Common button styling constants
export const BUTTON_STYLES = {
  small: {
    fontSize: '12px',
    padding: '2px 8px'
  }
};
export const INVOICE_ITEMS_FUNCTION_LIST = {
  3030: 'hardware_amount',
  3031: 'installation_amount',
  3032: 'cartage_amount',
  3033: 'tag_amount',
  3046: 'labour_amount',
  3045: 'consumable_amount'
};

export function isInvoiceItemZero(amounts, field) {
  const value = parseFloat(amounts[field]) ?? 0;
  return value === 0;
}
